<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormIndustry
      :Industry="editIndustry"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({ name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormIndustry from '../components/FormIndustry.vue';

export default {
  components: {
    FormIndustry,
  },
  name: 'EditIndustry',
  module: 'Industries',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing Industry. Default to {}.
      */
      editIndustry: {},
      /**
       * Query Id for Industry
       */
      industryId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('industries', ['industries', 'industry']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.industryId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_industry(this.industryId);
      this.editIndustry = this.industry;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('industries', ['LOAD_industry', 'CREATE_industry', 'UPDATE_industry']),
    /** Method used to save the item
     */
    async save(industry) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_industry(industry);
      } else {
        await this.UPDATE_industry(industry);
      }
      this.isSaving = false;
      this.$router.push({ name: 'clients-ListIndustry' });
    },
  },
};
</script>

<docs>
# EditIndustry example

'''js
<EditIndustry :Industry="Industry" />
'''
</docs>
